module.exports = __webpack_public_path__ + "static/media/xtreme_visual.70860541.jpg";